var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 31.5,
    r: 9,
    fill: "white",
    stroke: "#DA1C23"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 31.5,
    r: 6.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 31.5,
    r: 6.5,
    fill: "#FF4343",
    fillOpacity: 0.41
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18C18.825 18 19.5315 17.706 20.1195 17.118C20.7065 16.531 21 15.825 21 15C21 14.175 20.7065 13.4685 20.1195 12.8805C19.5315 12.2935 18.825 12 18 12C17.175 12 16.469 12.2935 15.882 12.8805C15.294 13.4685 15 14.175 15 15C15 15.825 15.294 16.531 15.882 17.118C16.469 17.706 17.175 18 18 18ZM18 32.4375C17.8 32.4375 17.6 32.4 17.4 32.325C17.2 32.25 17.025 32.15 16.875 32.025C13.225 28.8 10.5 25.8065 8.7 23.0445C6.9 20.2815 6 17.7 6 15.3C6 11.55 7.2065 8.5625 9.6195 6.3375C12.0315 4.1125 14.825 3 18 3C21.175 3 23.9685 4.1125 26.3805 6.3375C28.7935 8.5625 30 11.55 30 15.3C30 17.7 29.1 20.2815 27.3 23.0445C25.5 25.8065 22.775 28.8 19.125 32.025C18.975 32.15 18.8 32.25 18.6 32.325C18.4 32.4 18.2 32.4375 18 32.4375Z",
    fill: "#DA1C23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.05af30e9db5d4d5f28a1d33f2edb36ec.svg";
export { ForwardRef as ReactComponent };